<template>
  <div>
    <div class="header">
      <topHeader></topHeader>
    </div>
    <div class="main">
      <div v-if="indexPermissions == true">
        <router-view></router-view>
      </div>

      <div class="soucre-layer" v-else>
        <div class="soucre-layer-block">
          <img class="soucre-layer-block-img" src="@/assets/images/jurisdiction.png" />

          <div class="soucre-layer-block-text">暂无权限</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topHeader from "./top-header.vue";

export default {
  components: {
    topHeader,
  },
  data() {
    return {
      indexPermissions: true
    };
  },
  watch: {
    '$route'(to, from) { // 监听路由变化
      this.routerName(to)
    }
  },
  mounted() {
     // 页面刷新时执行一次
    this.routerName(this.$route)
  },
  methods: {
    routerName(item) {
      let str = item.path.slice(1).split('/')[0]; 
      console.log('出发1111',  this.$store.state.premissions.sidebarMenu)
      console.log('str', str)

      this.$store.state.premissions.sidebarMenu.forEach(info => {
        if(info.name == str) {
          console.log('info', info)
          this.indexPermissions = info.show
        }
      });
    }
  }

};
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 10px;
}

.main {
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;

  .soucre-layer {
    width: 100%;
    height: calc(100vh - 140px);
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;

    &-block {
      &-img {
        width: 150px;
        height: 150px;
      }

      &-text {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        text-align: center;
      }
    }
  }
}
</style>